import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NEWS_FEATURE_KEY } from '../keys';
import { NewsState } from '../reducers/news.reducer';

const selectState = createFeatureSelector<NewsState>(NEWS_FEATURE_KEY);

export const selectNews = createSelector(selectState, (state: NewsState) => state.data);
export const selectNewsLoading = createSelector(selectState, (state: NewsState) => state.loading);
export const selectNewsLoaded = createSelector(selectState, (state: NewsState) => state.loaded);
